<app-cue-table #splitReworkTable *ngIf="splitTableDatasource" [dataset]="splitTableDatasource" [gridOptions]="splitTableConfigs" [columnDefinitions]="splitTableColumnConfigs" [callback]="splitTableCallbacks" (onSelectionChanges)="onGridSelectionChanges($event)">
</app-cue-table>
<div class="pop_footer">
    <span><button class="btn btn-primary" (click)="onCompute()" [disabled]="canRestrictSplitOrCompute">Compute</button></span>
    <span class="align-right col-md-6 secondory_btn">
  <button class="btn btn-primary" (click)="onCloseModal()">Close</button>
  <button class="btn btn-primary" (click)="onConfirmSplit()" [disabled]="canRestrictSplitOrCompute">Split</button>
</span>
</div>